module.exports = __webpack_public_path__ + "Sides.png";